<template>
  <div class="confirmation-container mt-2">
    <span class="font-bold">Cancel Appointment</span>
    <TextArea
      v-model="reason"
      class="full-width"
      name="reason"
      label="Reason:"
      :rows="3"
      :validation-errors="v$.$errors"
      placeholder="Cancellation reason..."
    />
    <div class="summary my-2">
      <div class="font-bold">Cancelling this appointment will:</div>
      <div>- Change the status to Cancelled</div>
      <div>- {{ cancelationText }}</div>
    </div>
    <div class="button-container">
      <Button
        :saving="saving"
        text="Cancel Appointment"
        type="danger"
        @click="handleCancelAppointment"
      />
      <Button
        outline
        text="Keep Appointment"
        @click="$emit('close-confirmation')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    Button,
    TextArea
  },
  emits: ["close-confirmation"],
  data() {
    return {
      reason: "",
      saving: false
    };
  },
  computed: {
    ...mapState(["appointment"]),
    cancelationText() {
      return `Send an email notification to ${this.appointment.customer.full_name} that the appointment has been cancelled`;
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      reason: {
        required: {
          ...required,
          $message: "Reason required"
        },
        $autoDirty: true
      }
    };
  },
  methods: {
    ...mapActions(["cancelAppointment"]),
    handleCancelAppointment() {
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          this.saving = true;
          this.cancelAppointment({
            id: this.appointment.id,
            reason: this.reason
          })
            .then(() => this.$emit("close-confirmation"))
            .finally(() => {
              this.saving = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.confirmation-container {
  padding: 10px;
  border: 1px solid var(--gray-border-color);
  background: #fff;
}

.summary {
  background: var(--light-gray);
  border: 1px solid var(--gray);
  border-radius: 5px;
  padding: 10px;
}
</style>
